<div class="pricing-modal">
  <button class="close-btn" aria-label="Close" (click)="close()">
    <i class="bi bi-x-lg"></i>
  </button>
      <h2 class="title text-center">{{action}} configuration?</h2>
  <p class="text-center">
    Are you sure you want to {{action}}
    <strong>{{rulesetName}}</strong>?
  </p>
  <div class="d-flex justify-content-center gap-4">
  <button  type="button" class="btn-add cancel" (click)="close()">
    Cancel 
  </button>
  <button type="button" class="btn-add" (click)="goToUpgradePlan()">
    {{action}}
  </button>
  </div>
</div>
